import React, { useEffect, useMemo, useState,useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import { PermissionContext } from "../../context/PermissionContext";
import Cookies from "js-cookie";

import {
  getTeacherListApiCall,
  editTeacherDataApiCall,
} from "../../Store/slices/teacherSlice";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";

export default function ManageTeacher() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const [isActive, setIsActive] = useState("Inactive");
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };


  let userData = Cookies.get("dataCA")
  ? JSON.parse(Cookies.get("dataCA"))
  : null;
const role = userData ? userData.role : null;
const { permissions } = useContext(PermissionContext);

  const handleSortChange = (fieldName, sort) => {
    setFieldSort(`${fieldName} ${sort}`);
    setSortColumn(fieldName);
    setAscSort(sort === "asc");
  };

  const {
    TeacherList: { data: TeacherList },
  } = useSelector((state) => state.teacher);
  //console.log('TeacherList :', TeacherList);

  useEffect(() => {
    handleTeacherListAPI();
  }, [page, debounce, fieldSort]);

  const handleTeacherListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
    };
    dispatch(getTeacherListApiCall(submitData));
  };

  const handleStatusChange = async (id, currentStatus) => {
    //console.log("currentStatus :", currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    let submitData = { id, status: newStatus };

    try {
      await dispatch(editTeacherDataApiCall(submitData));
      dispatch(getTeacherListApiCall({
        search: debounce,
        page: page,
        fieldSort: fieldSort,
      }));

      SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Deleted",
        };
        try {
          await dispatch(editTeacherDataApiCall(submitData));
          await SWIT_DELETE_SUCCESS(`Teacher deleted successfully`);

          // Refresh the teacher list after deletion
          handleTeacherListAPI();
        } catch (error) {
          console.error("Error deleting teacher:", error);
        } finally {
          dispatch(setLoader(false));
        }
      }
    });
  };

  const companyListData = useMemo(() => {
    //console.log("TeacherList :", TeacherList);
    return TeacherList?.map((item, index) => (
      <tr key={index}>
        <td>{item?.id}</td>
        <td>{item?.name}</td>
        <td>{item?.email}</td>
        <td>{item?.phone}</td>
        {role == "admin" ||
          (permissions[2]?.module_id === 3 &&
            permissions[2]?.permission_update === 1) ? (
            <td>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`is_active_${item.id}`}
                  checked={item?.status === "Active"}
                  onChange={(e) => {
                    // console.log("e--------------------", e.target.value);
                    handleStatusChange(item?.id, item?.status);
                  }}
                />
              </div>
            </td>
          ) : (
            <td>{item?.status}</td>
          )}
        <td>
          <a
            className="text-reset fs-18 cursor_pointer"
            onClick={() =>
              navigate(`/manage_teacher/view_teacher_details`, {
                state: { teacherData: item },
              })
            }
          >
            <i className="ri-eye-line"></i>
          </a>

          {role == "admin" ||
          (permissions[2]?.module_id === 3 &&
            permissions[2]?.permission_delete === 1) ? (
              <a
              className="text-reset fs-18 cursor_pointer"
              onClick={() => handleDeleteManage(item?.id)}
            >
              <i className="ri-delete-bin-6-line"></i>
            </a>
          ) : (
            null
          )}
        </td>
      </tr>
    ));
  }, [TeacherList]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Teacher`} header={`Teacher`} />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`teacher`}
                  setSearch={setSearch}
                  isExport={false}
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(TeacherList)?.length > 0 ? (
                      <>
                        <table className="table table-centered mb-0 table-hover">
                          <thead>
                            <tr>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                ID
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "name"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "name",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Name
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "email"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "email",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Email
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "phone_no"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "phone_no",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Phone
                              </th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("Teacher")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={TeacherList[0]?.teacher_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Teacher`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
